"use client";
import React from "react";
import { CommentType } from "../../../constants/mockPosts";
import { useState } from "react";
import Image from "next/image";
const Comment = ({ comment }: { comment: CommentType }) => {
  const [showReplies, setShowReplies] = useState(false);

  return (
    <div className=" border-gray-300 text-secondary-main my-4">
      <div className="flex items-start gap-5">
        <Image
          height={48}
          width={48}
          src={comment.photo}
          alt={comment.name}
          className="size-12 object-cover bg-themeColor-70 rounded-full"
        />
        <div>
          <h5 className="font-semibold">{comment?.name}</h5>
          <p className="text-sm text-label-main">
            {new Date(comment.date).toDateString()}
          </p>
          <p className="mt-1">{comment.text}</p>
          {comment?.replies?.length > 0 && (
            <button
              onClick={() => setShowReplies(!showReplies)}
              className="text-themeColor text-sm mt-2"
            >
              {showReplies
                ? "Hide Replies"
                : `Show Replies (${comment?.replies?.length})`}
            </button>
          )}
          {showReplies && (
            <div className="mt-2 ml-5 border-gray-200 pl-3">
              {comment.replies.map((reply) => (
                <Comment key={reply?.id} comment={reply} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Comment;
